// Simple user activity logger for detailed individual tracking
import { db } from '../firebase';
import { collection, addDoc, query, where, orderBy, getDocs, limit } from 'firebase/firestore';

// Log user activity to Firestore for detailed analysis
export const logUserActivity = async (userId, activity, details = {}) => {
  if (!userId) return;
  
  try {
    await addDoc(collection(db, 'userActivity'), {
      userId,
      activity,
      details,
      timestamp: new Date(),
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString()
    });
  } catch (error) {
    console.error('Error logging user activity:', error);
  }
};

// Get user activity history
export const getUserActivity = async (userId, days = 7) => {
  if (!userId) return [];
  
  try {
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - days);
    
    const q = query(
      collection(db, 'userActivity'),
      where('userId', '==', userId),
      where('timestamp', '>=', cutoffDate),
      orderBy('timestamp', 'desc'),
      limit(100)
    );
    
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching user activity:', error);
    return [];
  }
};

// Get all users' recent activity summary
export const getAllUsersActivity = async (hours = 24) => {
  try {
    const cutoffDate = new Date();
    cutoffDate.setHours(cutoffDate.getHours() - hours);
    
    const q = query(
      collection(db, 'userActivity'),
      where('timestamp', '>=', cutoffDate),
      orderBy('timestamp', 'desc'),
      limit(50)
    );
    
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching all users activity:', error);
    return [];
  }
};

// Activity types to track
export const ACTIVITY_TYPES = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  CREATE_EVENT: 'create_event',
  EDIT_EVENT: 'edit_event',
  DELETE_EVENT: 'delete_event',
  IMPORT_EMAILS: 'import_emails',
  GENERATE_TLDR: 'generate_tldr',
  VIEW_CALENDAR: 'view_calendar',
  SHARE_EVENT: 'share_event',
  PAGE_VIEW: 'page_view'
};